import { render, staticRenderFns } from "./ArticleInfoFullTemplate.vue?vue&type=template&id=ba0723aa"
import script from "./ArticleInfoFullTemplate.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoFullTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoFullTemplate.vue?vue&type=style&index=0&id=ba0723aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports